module.exports = __webpack_public_path__ + "static/media/uniserved_logo.b9c20f07.png";